<template>
  <div class="xdropdown" @mouseenter="mouseEnter" @mouseleave="mouseLeave" ref="dropdown">
    <div class="title" ref="title" @click="handleClick">
      <span class="name ellipsis"><slot></slot></span>
      <img src="~@/assets/images/icons/search/dropdown.png" class="title-icon">
    </div>
    <slot name="list"></slot>
  </div>
</template>

<script>
export default {
  name: 'XDropdown',
  data () {
    return {
      optionID: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.dropmenu = this.getDropMenu()[0] || null
      this.$on('selectItem', (event, id, name) => {
        this.optionID = id
        this.setDropMenuState(false)
        this.$refs.title.querySelector('.name').innerHTML = this._h.removeTag(name)
        this.$emit('change', event, id, name)
      })
    })
  },
  methods: {
    selectOption (id, sel) {
      if (id !== this.optionID) {
        let option = this.$refs.dropdown.querySelector(`li${sel}`)
        if (option) {
          this.optionID = id
          let name = this._.trim(option.innerHTML)
          this.$refs.title.querySelector('.name').innerHTML = this._h.removeTag(name)
        }
      }
    },
    getDropMenu () {
      return this.$children.filter(item => item.$options.name === 'XDropdownMenu') || []
    },
    getDropMenuState () {
      if (this.dropmenu) {
        return this.dropmenu.isShow
      } else {
        return false
      }
    },
    setDropMenuState (v) {
      if (this.dropmenu) {
        this.dropmenu.isShow = v
      }
    },
    mouseEnter () {
      this.setDropMenuState(true)
    },
    mouseLeave () {
      this.setDropMenuState(false)
    },
    handleClick () {
      this.setDropMenuState(!this.getDropMenuState())
    }
  }
}
</script>
<style scoped>
  .xdropdown{
    position: relative;
  }
  .title{
    cursor: pointer;
    text-align: center;
    /* background:  url("~@/assets/images/icons/search/dropdown.png") no-repeat right 10px center transparent;
    background-size: 6px; */
    padding: 0 15px 0 6px;
    position: relative;
  }
  .title-icon{
    transition: all 0.3s;
    position: absolute;
    width: 8px;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .title:hover .title-icon{
    transform: translateY(-50%) rotate(180deg);
  }
  .title .name{
    position: absolute;
    top:50%;
    left: 6px;
    right: 15px;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/common/xdropdown/XDropdown.vue